import { ErrorPage } from '../index';
import { initServerTranslation } from '@bts-web/utils-lokalise';

const ErrorAuthExpiredPage = async () => {
  const { t } = await initServerTranslation();

  return (
    <ErrorPage
      title={t('session_expired_error_text')}
      description={t('general_error_text')}
    />
  );
};

export { ErrorAuthExpiredPage };
